import ChartPanel from '/components/statistics/chart-panel'
import FilterBar from '/components/statistics/filter-bar'
import PageShell from '/components/statistics/page-shell'
import useClientStatistics from '/components/statistics/use-client-statistics'

const compactChartSetting = {
  yAxis: [{ label: 'count', width: 90 }]
}

const StatisticsPassTypes = () => {
  const { loading, periodDays, setPeriodDays, selectableTemplates, statistics, templateId, setTemplateId } = useClientStatistics('passTypes')

  return (
    <PageShell title="Statistics Pass Types" heading="Statistics - Pass Types">
      <div className='flex flex-col gap-5 mt-5 pb-20'>
        <FilterBar
          periodDays={periodDays}
          setPeriodDays={setPeriodDays}
          templateId={templateId}
          setTemplateId={setTemplateId}
          selectableTemplates={selectableTemplates}
          showTemplateSelector={false}
        />

        <ChartPanel
          title='Pass type mix'
          description='Shows which pass types are seeing the most live issuance across the selected scope.'
          dataset={statistics.passTypeMix}
          xAxis={{ scaleType: 'band', dataKey: 'pass_type_name' }}
          series={[
            { dataKey: 'issued', label: 'Issued' },
            { dataKey: 'template_count', label: 'Templates' }
          ]}
          loading={loading}
          height={380}
          yAxis={compactChartSetting.yAxis}
        />
      </div>
    </PageShell>
  )
}

export default StatisticsPassTypes
